module.exports = __webpack_public_path__ + "img/党建2.6b311db0.jpg";